import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { WorkflowTaskHumanSavePage } from './workflow-task-human-save.page';
import { CardModule } from '../../../../../core/component/card/card.module';
import { DatePickerModule } from '../../../../../../components/common/date-picker/date-picker.module';
import {
    UserSelectFilterModule
} from '../../../../../account/modules/user/api/component/user-select-filter/user-select-filter.module';
import { CreateMessageModule } from '../../../../../message/api/component/create-message/create-message.module';
import { FormFieldModule } from '../../../../../core/component/form-field/form-field.module';
import {
    LovValueSelectFilterModule
} from '../../../../../common/lov/lov-value/api/component/lov-value-select-filter/lov-value-select-filter.module';
import { InputTextModule } from '../../../../../core/component/input-text/input-text.module';
import {DialogModule} from '../../../../../common/dialog/dialog.module';
import {
    CreateUpdateDefaultModule
} from '../../../../../core/component/create-update-default/create-update-default.module';
import {ButtonModule} from '../../../../../core/component/button/button.module';
import {LoadingModule} from '../../../../../../components/common/loading/loading.module';
import {RichTextEditorModule} from "../../../../../../components/common/rich-text-editor/rich-text-editor.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        CardModule,
        DatePickerModule,
        UserSelectFilterModule,
        CreateMessageModule,
        FormFieldModule,
        LovValueSelectFilterModule,
        InputTextModule,
        DialogModule,
        CreateUpdateDefaultModule,
        ButtonModule,
        LoadingModule,
        RichTextEditorModule,
    ],
    declarations: [WorkflowTaskHumanSavePage]
})
export class WorkflowTaskHumanSaveModule {
}
